// Erro lançado pelo login quando a API exige o segundo fator (TOTP).
// `invalid` indica que um código já foi enviado e estava incorreto.
export class MfaRequiredError extends Error {
  invalid: boolean;

  constructor(invalid: boolean) {
    super("MFA_REQUIRED");
    this.name = "MfaRequiredError";
    this.invalid = invalid;
  }
}
